<template>
    <pt-balance-detail class="pt-balance-detail__withData"  :detail="detail" @deleteBalanceDetail="deleteBalanceDetail" :departmentList="departmentList" @getBalanceDetail="getDetail"></pt-balance-detail>
</template>

<script>
import PtBalanceDetail from './index'
export default {
  name: 'pt-balance-detail__withData',
  components: {
    'pt-balance-detail': PtBalanceDetail
  },
  data () {
    return {
      detail: {},
      departmentList: []
    }
  },
  methods: {
    getDetail () {
      this.getBalanceDetail()
    },
    getDepartmentList () {
      this.$store.dispatch('getBusinessDepartment').then(res => {
        var newArr = []
        res.forEach(ele => {
          var obj = {}
          let val = {
            id: ele.id,
            name: ele.name
          }
          obj.value = JSON.stringify(val)
          obj.label = ele.name
          newArr.push(obj)
        })
        this.departmentList = newArr
      }).catch(err => {
        this.loading = false
        this.$message(err || '获取事业部列表失败')
      })
    },
    getBalanceDetail () {
      this.$store.dispatch('getBalanceDetail', this.$route.params.id).then(ret => {
        this.detail = ret
      }).catch(err => {
        this.$message.error(err || '获取账户额度详情失败')
      })
    },
    deleteBalanceDetail (id) {
      this.$store.dispatch('deleteBalanceDetail', id).then(ret => {
        this.$message.success('删除账户额度信息成功')
        history.go(-1)
      }).catch(err => {
        this.$message.error(err || '删除账户额度信息失败')
      })
    }
  },
  created () {
    this.getDetail()
    this.getDepartmentList()
  }
}
</script>
